import { SVGProps } from 'react';

export default function Order6(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="timeline-layout--svg--icon"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_2313_3114)">
        <path
          d="M19.4333 3.41667C18.9583 2.83333 18.25 2.5 17.5 2.5H6.03333L6 2.20833C5.92783 1.6002 5.63525 1.03962 5.17762 0.632664C4.71999 0.225712 4.12907 0.000625667 3.51667 0L2.5 0C2.04167 0 1.66667 0.375 1.66667 0.833333C1.66667 1.29167 2.04167 1.66667 2.5 1.66667H3.51667C3.94167 1.66667 4.29167 1.98333 4.34167 2.4L5.49167 12.15C5.74167 14.25 7.51667 15.8333 9.63333 15.8333H16.6667C17.125 15.8333 17.5 15.4583 17.5 15C17.5 14.5417 17.125 14.1667 16.6667 14.1667H9.63333C8.55833 14.1667 7.63333 13.475 7.28333 12.5H15.1333C17.1167 12.5 18.8333 11.0917 19.2167 9.15L19.95 5.49167C20.0233 5.12913 20.0149 4.75483 19.9256 4.39592C19.8362 4.03702 19.6681 3.7025 19.4333 3.41667ZM9.16667 18.3333C9.16667 19.25 8.41667 20 7.5 20C6.58333 20 5.83333 19.25 5.83333 18.3333C5.83333 17.4167 6.58333 16.6667 7.5 16.6667C8.41667 16.6667 9.16667 17.4167 9.16667 18.3333ZM16.6667 18.3333C16.6667 19.25 15.9167 20 15 20C14.0833 20 13.3333 19.25 13.3333 18.3333C13.3333 17.4167 14.0833 16.6667 15 16.6667C15.9167 16.6667 16.6667 17.4167 16.6667 18.3333ZM0 5C0 4.54167 0.375 4.16667 0.833333 4.16667H2.11667C2.575 4.16667 2.95 4.54167 2.95 5C2.95 5.45833 2.575 5.83333 2.11667 5.83333H0.833333C0.375 5.83333 0 5.45833 0 5ZM0 8.33333C0 7.875 0.375 7.5 0.833333 7.5H2.5C2.95833 7.5 3.33333 7.875 3.33333 8.33333C3.33333 8.79167 2.95833 9.16667 2.5 9.16667H0.833333C0.375 9.16667 0 8.79167 0 8.33333ZM4.16667 11.6667C4.16667 12.125 3.79167 12.5 3.33333 12.5H0.833333C0.375 12.5 0 12.125 0 11.6667C0 11.2083 0.375 10.8333 0.833333 10.8333H3.33333C3.79167 10.8333 4.16667 11.2083 4.16667 11.6667Z"
          fill={props.fill || 'black'}
        />
      </g>
      <defs>
        <clipPath id="clip0_2313_3114">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
